import { connect } from "react-redux";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import {
  addExistingAttendee,
  clearAttendee
} from "../../state/actions/attendeeProfileActions";

let ExistingProfileModal = ({
  attendeeProfile,
  addExistingAttendee,
  clearAttendee
}) => {
  const { profileCheck } = attendeeProfile;
  const { ticketId, profile } = profileCheck;
  const footer = (
    <div style={{ display: "flex", width: "100%", padding: "0px 12px" }}>
      <div style={{ flexGrow: 1 }}>
        <Button onClick={clearAttendee}>Cancel</Button>
      </div>
      <div
        style={{ flexGrow: 1, display: "flex", flexDirection: "row-reverse" }}
      >
        <Button onClick={() => addExistingAttendee(ticketId, profile)}>
          Add Attendee Profile
        </Button>
      </div>
    </div>
  );
  return (
    <Modal
      closeHandler={clearAttendee}
      showModal={profile}
      footer={footer}
      padding={0}
      includeCloseButton={false}
    >
      <p style={{ padding: 20 }}>
        An attendee profile already exists with this email. Add existing
        attendee profile?
      </p>
    </Modal>
  );
};

export default connect(
  (state, ownProps) => {
    return {
      attendeeProfile: state.attendeeProfile
    };
  },
  {
    addExistingAttendee,
    clearAttendee
  }
)(ExistingProfileModal);



// WEBPACK FOOTER //
// ./routes/conferences/ExistingProfileModal.js